import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'

import { showLoader } from '@app/javascript/classes/loaderExtensions'
import { toggleResetFilter } from './mixins/toggleResetFilter'

export default class extends Controller {
  static targets = ['form', 'submitButton', 'resetButton']

  connect() {
    useDispatch(this)
    if (this.hasFormTarget) {
      this.formTarget.addEventListener('filters-container:filterCleared', this.triggerFilter.bind(this), {})
    }
    toggleResetFilter(this.resetButtonTarget, $(this.formTarget).serialize(), this.hasResetButtonTarget)
  }

  triggerFilter() {
    showLoader('#issues-loader')
    this.submitButtonTarget.click()
    const searchParams = $(this.formTarget).serialize()
    this.dispatch('formTriggered', {
      params: searchParams,
      filters_applied: $.deparam(searchParams)
    })
    this.dispatch('syncUrl', {
      searchParams: searchParams
    })
    toggleResetFilter(this.resetButtonTarget, searchParams, this.hasResetButtonTarget)
  }

  uncheckAll() {
    // this.actionSelectController().uncheckAll()
  }
}
